export const loader_quotes_en = [
  "We are analyzing your answers...",
  "We are evaluating your interests to suggest the best paths...",
  "We are calculating the costs of various study paths...",
  "We are estimating your future earnings based on possible paths...",
  "We are comparing the different academic paths available...",
  "We are analyzing job opportunities related to your interests...",
  "We are showing you what your academic and career future could look like...",
  "We are preparing a complete picture of the costs and benefits for you...",
  "We are building your personalized guide for the future...",
  "Almost done! You will soon discover the best study paths for you..."
];
